import { IApiResponse } from "../../store/@types/api-response";
import {
  IComplianceData,
  ICreateComplianceRequest,
  ICreateComplianceResponseData,
} from "../../store/@types/compliance";
import { setCompliances, setLoading } from "../../store/slices/compliance";
import { AppDispatch } from "../../store/store";
import axiosInstance from "../../utils/axiosInstance";
import { notify } from "../../components/alerts";
import { getErrorMessage } from "./apiError";

const complianceEndpoint = "/compliance/api/v1/compliance";

export const get_compliances = async (dispatch: AppDispatch): Promise<void> => {
  dispatch(setLoading(true));
  try {
    const response = await axiosInstance.get<IApiResponse<IComplianceData>>(
      `${complianceEndpoint}/process-requests/mine`,
    );

    if (!response.data.success) {
      throw new Error(
        response.data.message || "Failed to load compliance requests.",
      );
    }

    dispatch(setCompliances(response.data));
  } catch (error) {
    notify({
      type: "error",
      message: getErrorMessage(error, "Failed to load compliance requests."),
    });
  } finally {
    dispatch(setLoading(false));
  }
};

export const create_compliance_request = async (
  dispatch: AppDispatch,
  data: ICreateComplianceRequest,
): Promise<boolean> => {
  dispatch(setLoading(true));
  try {
    const response = await axiosInstance.post<
      IApiResponse<ICreateComplianceResponseData>
    >(`${complianceEndpoint}/process-requests`, data);

    if (!response.data.success) {
      throw new Error(
        response.data.message || "Failed to create compliance request.",
      );
    }

    notify({ type: "success", message: response.data.message });
    return true;
  } catch (error) {
    notify({
      type: "error",
      message: getErrorMessage(error, "Failed to create compliance request."),
    });
    return false;
  } finally {
    dispatch(setLoading(false));
  }
};

export const generate_compliance_document = async (
  dispatch: AppDispatch,
  service_id: number,
) => {
  dispatch(setLoading(true));
  try {
    await axiosInstance.post(
      `${complianceEndpoint}/applications/${service_id}/generate-documents`,
    );
  } catch (error) {
    notify({
      type: "error",
      message: getErrorMessage(error, "Failed to generate documents."),
    });
    return false;
  } finally {
    dispatch(setLoading(false));
  }
};
